import { Microservice } from "../model/microservice";
import { IPipeline } from "./pipeline.inferface";
import { TracingComponent } from "./tracing-component";

export class MicroservicePipeline implements IPipeline<Microservice, Promise<Microservice>> {

	constructor(

		private manifestLoader: TracingComponent<Microservice, Microservice>,
		private manifestValidator: TracingComponent<Microservice, Microservice>,
		private htmlLoader: TracingComponent<Microservice, Microservice>,
		private htmlValidator: TracingComponent<Microservice, Microservice>,
		private assetLoader: TracingComponent<Microservice, Microservice>
	) {}

	public async run(microservice: Microservice): Promise<Microservice> {

		this.manifestLoader.connectTo(this.manifestValidator);
		this.manifestValidator.connectTo(this.htmlLoader);
		this.htmlLoader.connectTo(this.htmlValidator);
		this.htmlValidator.connectTo(this.assetLoader);

		return await this.manifestLoader.process(microservice);
	}
}
